Skip to content
Search or jump to…
Pull requests
Issues
Marketplace
Explore
 
@cfingerh 
Dajolo1995
/
Min.-Hacienda
Private
2
0
1
Code
Issues
Pull requests
1
Actions
Projects
Security
Insights
Min.-Hacienda/src/views/acceso/components/user/CreateUsers.vue
@enio3020
enio3020 Correciones de RUT, VAlidar RUT
Latest commit 15134bc yesterday
 History
 2 contributors
@enio3020@Dajolo1995
579 lines (542 sloc)  13.8 KB
  
<template>
  <div>
    <b-row class="row-one">
      <div class="div-title">
        <CreateBlue />
        <h4 class="title">Agregar Nuevo Usuario</h4>
      </div>
    </b-row>

    <div class="form">
      <div class="error" v-if="errorMsg">
        {{ errorMsg }}
      </div>
      <form>
        <div class="div" v-show="1===2">
          <div class="text-width">
            <label class="label-text">Username</label>
          </div>

          <input
            type="text"
            v-model="user.username"
            placeholder="Nombre de Usuario"
            class="input"
          />
        </div>
        <div class="div" v-show="1===2">
          <div class="text-width">
            <label class="label-text">Contraseña</label>
          </div>

          <input
            type="password"
            v-model="user.password"
            placeholder="Contraseña"
            class="input"
          />
        </div>
        <div class="div" v-show="1===2">
          <div class="text-width">
            <label class="label-text">Confirmar Contraseña</label>
          </div>

          <input
            type="password"
            v-model="confirmPass"
            placeholder="Repetir Contraseña"
            class="input"
          />
        </div>
        <div class="div">
          <div class="text-width">
            <label class="label-text">RUT</label>
          </div>

          <input
            v-model="user.run"
            type="text"
            placeholder="44444444-4"
            class="input"
          />

         
          
        </div>
        <div class="div">
          <div class="text-width">
            <label class="label-text">E - mail</label>
          </div>

          <input
            v-model="user.email"
            type="email"
            placeholder="correo@correo.com"
            class="input"
          />
        </div>
        <div class="div">
          <div class="text-width">
            <label class="label-text">Perfil</label>
          </div>
          <b-form-select
            class="input"
            v-model="selectedProfile"
            :options="profileOptions"
          ></b-form-select>
        </div>
        <ServicesCheckboxAdministrador
          v-if="select_proFile"
          :serviceOptions="serviceOptions2"
          :selectedServicesToAdd="selectedServicesToAdd"
        />
        <div
          class="div"
          v-if="
            listServices &&
              isNotJSorEBGI() &&
              !ministersSelect && !select_proFile
          "
        >
          <div class="text-width">
            <label class="label-text">Servicio</label>
          </div>
          <b-form-select
            class="input"
            v-model="selectedService"
            :options="serviceOptions"
          ></b-form-select>
        </div>
        <div class="div" v-else-if="isAdmin && ministersSelect && ministerList">
          <div class="text-width">
            <label class="label-text">Ministerio</label>
          </div>
          <b-form-select
            class="input"
            v-model="selectedMinister"
            :options="ministerList"
          ></b-form-select>
        </div>
        <ServicesCheckbox
          v-if="selectedMinister"
          :selectedMinister="selectedMinister"
          :selectedServicesToAdd="selectedServicesToAdd"
        />

        <div class="boton">
          <b-button
            v-if="!selectedMinister && !select_proFile"
            @click="registrarUsuario"
            class="crear"
            >Crear</b-button
          >
          <b-button v-else @click="registrarMultipleServicio" class="crear"
            >Crear</b-button
          >
          <b-button @click="closeModal" class="btn-cerrar">Cerrar</b-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import CreateBlue from "../../../../components/icons/user/CreateBlue.vue";
import ServicesCheckbox from "./ServicesCheckbox.vue";
import ServicesCheckboxAdministrador from "./ServicesCheckboxAdministrador.vue";
import axios from "axios";
import { showAlert } from "../../../../components/tools/utils";
import { mapState } from "vuex";
import Vue from 'vue';
const VueInputMask = require('vue-inputmask').default;
Vue.use(VueInputMask);
export default {
  components: {
    CreateBlue,
    ServicesCheckbox,
    ServicesCheckboxAdministrador,
  },
  data() {
    return {
      rolUsuarioLogeado: null,
      showAlert: null,
      sumary_generarRut: 0,
      generarRut: "",
      multiplicar_Modulo11: 0,
      sub_resul_modulo11: 0,
      resul_modulo11: 0,
      digito_aux: "",
      modulo11: 0,
      rut_aux: "",
      confirmPass: "",
      array_multiplicar: [2,3,4,5,6,7,2,3],
      user: {
        username: "",
        password: "",
        run: "",
        email: "",
      },
      selectedProfile: null,
      selectedService: null,
      selectedMinister: null,
      serviceOptions: [{ value: null, text: "- Seleccionar Servicio -" }],
      serviceOptions2: [],
      errorMsg: null,
    };
  },
  props: [
    "listServices",
    "profileOptions",
    "showModal",
    "closeModal",
    "getUsers",
    "ministerList",
    "relacionUS",
  ],
  computed: {
    ...mapState("sesion", ["usuario"]),
    select_proFile: function() {
      if (!this.isAdmin){
        if (this.selectedProfile === 6){
          return true;
        } else { 
          return false;
        }
      } else {
        return false;
      }
    },
    isAdmin: function() {
      return this.usuario.username === process.env.VUE_APP_USER_ADMIN;
    },
    ministersSelect: function() {
      if (this.isAdmin) {
        return this.selectedProfile === 2 || this.selectedProfile === 6
      }
      return this.selectedProfile === 2;
    },
  },
  watch: {
    selectedProfile: async function() {
      if (this.selectedProfile !== 2 && this.selectedProfile !== 6) {
        this.selectedMinister = null;
      }
    },
    generarRut: function (value) {
      this.rut_aux = value;
      this.digito_aux = ''+this.generar_digito_rut(this.rut_aux);
      this.user.run = this.rut_aux+'-'+this.digito_aux;
      document.getElementById("inputDigitoRut").value = '- '+this.digito_aux;
    }
  },
  methods: {
    validaRut: function(rutCompleto) {
        if (!/^[0-9]+-[0-9kK]{1}$/.test(rutCompleto))
            return false;
        var tmp = rutCompleto.split('-');
        var digv = tmp[1];
        var rut = tmp[0];
        if (digv == 'K') digv = 'k';
        return (this.generar_digito_rut(rut) == digv);
    },
    generar_digito_rut: function(T){
      var M=0,S=1;
      for(;T;T=Math.floor(T/10))
        S=(S+T%10*(9-M++%6))%11;
      return S?S-1:'k';
    },
    isNotJSorEBGI: function() {
      if (this.isAdmin) {
        this.rolUsuarioLogeado = 1;
      } else {
        this.rolUsuarioLogeado = this.relacionUS.rolId;
      }
      return this.rolUsuarioLogeado !== 4 && this.rolUsuarioLogeado !== 3;
    },
    selectedServicesToAdd: function(data) {
      this.selectedService = data;
    },
    crearUsuario: async function() {
      let toReturn;
      try {
        const token = localStorage.getItem("userToken");
        const res = await axios.post(
          `${process.env.VUE_APP_RUTA_API}/usuarios/usuarios/`,
          this.user,
          {
            headers: {
              Authorization: `JWT ${token}`,
            },
          }
        );
        toReturn = res.data.id;
      } catch (error) {
        console.log(error);
        showAlert({
          icon: "error",
          text: error.response.data[Object.keys(error.response.data)[0]],
          timerProgressBar: true,
          timer: 3000,
        });
      }
      return toReturn;
    },
    registrarUsuario: async function() {
      // if (this.user.password !== this.confirmPass) {
      //   this.activarError("Las contraseñas no coinciden");
      //   return;
      // }
      // if (this.user.password.length < 8) {
      //   this.activarError(
      //     "La contraseña es muy corta, debe tener por lo menos 8 caracteres"
      //   );
      // }
      console.log(this.user.run);
      if (
        this.user.run.split("-")[0].length < 7 ||
        this.user.run.split("-")[0].length > 9
      ) {
        this.activarError(
          "El RUT no es válido. Formato: X.XXX.XXX-X y XX.XXX.XXX-X"
        );
        return;
      }
      if(!this.validaRut(this.user.run)){
        this.activarError("RUT no valido, por favor verificar.");
        return;
      }
      if (!this.selectedProfile) {
        this.activarError("El perfil es obligatorio");
        return;
      }
      try {
        const token = localStorage.getItem("userToken");
        const id = await this.crearUsuario();
        if (!id) return;
        const usrObj = {
          usuario: id,
          servicio:
            this.rolUsuarioLogeado === 3 || this.rolUsuarioLogeado === 4
              ? this.$route.params.idServicio
              : this.selectedService,
          rol: this.selectedProfile,
        };
        await axios.post(
          `${process.env.VUE_APP_RUTA_API}/instituciones/usuarioservicio/`,
          usrObj,
          {
            headers: {
              Authorization: `JWT ${token}`,
            },
          }
        );
        showAlert({
          icon: "success",
          text: "Usuario registrado correctamente",
          timerProgressBar: true,
          timer: 3000,
        });
        this.getUsers();
        this.closeModal();
      } catch (error) {
        console.log(error.response.data);
        showAlert({
          icon: "error",
          text: error.response.data[Object.keys(error.response.data)[0]],
          timerProgressBar: true,
          timer: 3000,
        });
      }
    },
    registrarMultipleServicio: async function() {
      if (
        this.user.run.split("-")[0].length < 7 ||
        this.user.run.split("-")[0].length > 9
      ) {
        this.activarError(
          "El RUT no es válido. Formato: XXXXXXX-X y XXXXXXXX-X"
        );
        return;
      }
      if(!this.validaRut(this.user.run)){
        this.activarError("RUT no valido, por favor verificar.");
        return;
      }
      if (!this.selectedProfile) {
        this.activarError("El perfil es obligatorio");
        return;
      }
      
      if (this.selectedService.length === 0) {
        this.activarError("No ha sido seleccionado ningún servicio.");
        return;
      }
      const token = localStorage.getItem("userToken");
      const id = await this.crearUsuario();
      if (!id) return;
      let reqError = [],
        usrObj;
      this.selectedService.forEach(async (idService) => {
        try {
          usrObj = {
            usuario: id,
            servicio: idService,
            rol: this.selectedProfile,
          };
          await axios.post(
            `${process.env.VUE_APP_RUTA_API}/instituciones/usuarioservicio/`,
            usrObj,
            {
              headers: {
                Authorization: `JWT ${token}`,
              },
            }
          );
        } catch (error) {
          console.log(error);
          reqError.push(
            error.response.data[Object.keys(error.response.data)[0]]
          );
        }
      });
      if (reqError.length === 0) {
        showAlert({
          icon: "success",
          text: "Usuario registrado correctamente",
          timerProgressBar: true,
          timer: 3000,
        });
        this.getUsers();
        this.closeModal();
      } else {
        showAlert({
          icon: "error",
          text: reqError.join("\n"),
          timerProgressBar: true,
          timer: 3000,
        });
      }
    },
    activarError: function(msg) {
      this.errorMsg = `*${msg}`;
      setTimeout(() => {
        this.errorMsg = null;
      }, 4000);
    },
    showSwal: function(type, msg, showConfirmButton, timer) {
      this.showAlert = {
        icon: type,
        title: msg,
        showConfirmButton: showConfirmButton,
        timer: timer,
      };
      setTimeout(() => {
        this.showAlert = null;
      }, timer);
    },
  },
  mounted() {
    if (this.listServices) {
      this.serviceOptions = this.listServices;
      for(var i = 1; i < this.listServices.length; i++){
        console.log(i);
        this.serviceOptions2.push(this.listServices[i]);
      } 
    } else {
      this.selectedService = this.$route.params.idServicio;
    }
    if (!this.relacionUS) {
      this.rolUsuarioLogeado = 1;
    } else {
      this.rolUsuarioLogeado = this.relacionUS.rolId;
    }
  },
};
</script>

<style scoped>
.row {
  margin: 0;
  text-align: center;
}
.row-one {
  background: #24c6ab;
  display: flex;
  height: 60px;
  align-items: center;
}
.title {
  color: #052333;
  margin: 0 !important;
}
.form {
  margin: 30px;
}
.div {
  margin: 10px 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.input {
  background: #e0e0e0;
  border: none;
  width: 250px;
  font-size: 14px;
  color: #595959;
  padding: 0.4rem;
}
#inputRut {
  background: #e0e0e0;
  border: none;
  width: 100px;
  font-size: 14px;
  color: #595959;
  padding: 0.4rem;
}
#inputDigitoRut {
  background: #e0e0e0;
  border: none;
  width: 150px;
  font-size: 14px;
  color: #595959;
  padding: 0.4rem;
}
.label-text {
  font-size: 14px;
}
.text-width {
  width: 20%;
}
.boton {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 30px 0;
}
.crear {
  background: #0069d9;
  border: none;
  border-radius: 40px;
  margin: 0 10px;
}
.btn-cerrar {
  background: #e73f4b;
  border-radius: 40px;
  border: none;
  margin: 0 10px;
}
.div-title {
  display: flex;
  justify-content: center;
  align-items: center;
}
.cnt-error {
  display: flex;
  justify-content: center;
}
.error {
  color: #c23535;
  font-size: 0.8rem;
  text-align: center;
}
.selectables {
  background: #e0e0e0;
  padding: 10px;
  margin: 0 40px;
}
label.custom-control-label {
  margin: 0 3px !important;
  font-size: .8rem;
}
#__BVID__468__BV_label_ > b {
  font-size: .9rem;
}
</style>
